import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetActivarDEE: null,
    statusSetActivarDEE: null,
    activarDEE: [],
    activarDEEConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setActivarDEE (state, data) {
      state.activarDEE = data
    },
    setResponseUpdateActivarDEEConfig (state, data) {
      state.statusSetActivarDEE = data
    },
    setResponseGetActivarDEE (state, data) {
      state.statusGetActivarDEE = data
    },
    setResponseActivarDEEMsg (state, data) {
      state.activarDEEConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getDEEConfig ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getDEEConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setActivarDEE', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetActivarDEE', true)
            commit('setResponseActivarDEEMsg', 'Hubo un error obteniendo la configuración de documento equivalente eletrónico. Intentelo nuevamente.')
          } else {
            commit('setResponseGetActivarDEE', false)
            commit('setResponseActivarDEEMsg', 'Configuración de documento equivalente eletrónico consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetActivarDEE', true)
          commit('setResponseActivarDEEMsg', 'No pudo obtener  configuración de documento equivalente eletrónico. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateActivarDEEConfig ({ commit }, data) {
      const endpoint = '/api/updateDEEConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateActivarDEEConfig', true)
              commit('setResponseActivarDEEMsg', 'Hubo un error guardando la configuración de documento equivalente eletrónico. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateActivarDEEConfig', false)
              commit('setResponseActivarDEEMsg', 'Configuración de cambio de documento equivalente eletrónico guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateActivarDEEConfig', true)
          commit('setResponseActivarDEEMsg', 'No pudo obtener información de la configuración de documento equivalente eletrónico.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateActivarDEEConfig', data)
    },
    statusGetActivarDEE ({ commit }, data) {
      commit('setResponseGetActivarDEE', data)
    },
  },
}
